module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_M5-fb4e1dae038dd71f4e9d83fd2029edc2.webp";